import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-5">
            <h2 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.9]">
              Worn by<br />
              patience.<br />
              <span className="text-[#C9A961]">Made with</span><br />
              precision.
            </h2>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <div className="label-eyebrow text-white/50 mb-6">Atelier</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/shop" className="link-underline">Shop all</Link></li>
              <li><Link to="/shop?category=kids" className="link-underline">Kids collection</Link></li>
              <li><Link to="/shop?category=limited" className="link-underline">Limited editions</Link></li>
              <li><Link to="/custom" className="link-underline">Custom &amp; Bulk</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="label-eyebrow text-white/50 mb-6">House</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="link-underline">Atelier</Link></li>
              <li><a href="#" className="link-underline">Journal</a></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/50">
          <div className="flex items-center gap-4">
            <span>© {new Date().getFullYear()} The Crown &amp; Stitch — Hand-finished in small batches.</span>
            <span>Est. MMXXVI</span>
          </div>
          <div className="flex items-center gap-3">
            {/* Replace the href values with your handles (include full URL, e.g. https://instagram.com/yourhandle) */}
            <a
              href="https://www.instagram.com/crown_and_stitch01/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-white/80 hover:text-white transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.2" />
                <path d="M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="17.5" cy="6.5" r="0.7" fill="currentColor" />
              </svg>
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61589905772135"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="text-white/80 hover:text-white transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M18 2h-3a4 4 0 00-4 4v3H8v4h3v8h4v-8h3l1-4h-4V6a1 1 0 011-1h3V2z" fill="currentColor" />
              </svg>
            </a>

            <a
              href="https://in.pinterest.com/crownandstitch01/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pinterest"
              className="text-white/80 hover:text-white transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M12 2C6.48 2 2 6.48 2 12c0 3.54 1.99 6.59 4.86 8.15-.07-.69-.13-1.75.03-2.5.14-.62.9-3.95.9-3.95s-.23-.46-.23-1.14c0-1.07.62-1.87 1.39-1.87.66 0 .98.5.98 1.1 0 .67-.43 1.67-.65 2.6-.19.78.4 1.42 1.19 1.42 1.43 0 2.53-1.51 2.53-3.69 0-1.93-1.39-3.28-3.38-3.28-2.31 0-3.67 1.73-3.67 3.52 0 .69.26 1.43.59 1.83.06.07.07.13.05.2-.06.22-.2.7-.23.8-.04.13-.15.17-.34.1-1.27-.59-2.06-2.47-2.06-3.98 0-3.24 2.36-6.21 6.79-6.21 3.56 0 5.98 2.54 5.98 5.93 0 3.57-2.25 6.44-5.38 6.44-1.05 0-2.04-.55-2.38-1.2 0 0-.51 1.95-.63 2.41-.23.83-.85 1.87-1.27 2.51C9.76 21.9 10.86 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" fill="currentColor" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
